import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import { PendingChangesAware } from 'app/components/guards/pendingChanges.guard';
import { Globals } from 'app/globals/globals';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { UserModel } from 'app/views/user/models/user.model';

@Component({
    selector: 'edit-account',
    templateUrl: 'editAccount.component.html'
})

export class EditAccountComponent implements OnInit, PendingChangesAware {
    private uid: string;
    private logger: Logger;

    public email: string;
    private oldEmail: string;
    public user: UserModel = new UserModel();
    public isWaiting: boolean;

    public form: FormGroup;
    public firstnamefc: FormControl;
    public lastnamefc: FormControl;
    public emailfc: FormControl;

    constructor(
        private authService: AuthService,
        private repo: UserRepository,
        private globals: Globals,
        private toasterService: ToasterService,
        loggerFactory: LoggerFactory
    ) {
        this.logger = loggerFactory.create('EditAccountComponent');
    }

    public async ngOnInit() {
        this.isWaiting = true;
        let afUser = await this.authService.getCurrentUser();

        this.uid = afUser.uid;
        this.email = afUser.email;
        this.oldEmail = afUser.email;
        this.repo.get(this.uid).then(user => this.user = user ? user : this.user);

        this.ngOnChanges();
        this.isWaiting = false;
    }
    
    @HostListener('window:beforeunload')
    public hasPendingChanges() {
        return this.form.dirty;
    }

    public ngOnChanges() {

        this.firstnamefc = new FormControl(this.user.firstName, [
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(this.globals.shortStringLength)
        ]);

        this.lastnamefc = new FormControl(this.user.lastName, [
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(this.globals.shortStringLength)
        ]);

        this.emailfc = new FormControl(this.email, [
            Validators.required,
            Validators.email,
            Validators.minLength(this.globals.emailStringMinLength),
            Validators.maxLength(this.globals.emailStringMaxLength)
        ]);

        this.form = new FormGroup({
            firstnamefc: this.firstnamefc,
            lastnamefc: this.lastnamefc,
            emailfc: this.emailfc
        });
    }

    public async editAccount() {
        this.isWaiting = true;
        if (this.form.valid) {
            try {
                await this.repo.set(this.uid, this.user);
                if (this.emailfc.dirty && (this.email !== this.oldEmail)) {
                    await this.authService.updateEmail(this.email);
                }
                this.toasterService.pop('success', undefined, 'modules.account.edit.success');
            } catch (err) {
                this.toasterService.pop('error', undefined, 'errors.unknown');
            }
        }
        this.isWaiting = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/options/editAccount.component.ts